export enum SeoListName {
  RECOMMENDS_LIST_NAME = 'Menu Promocje',
  REPLACEMENTS_LIST_NAME = 'Zamienniki',
  BASKET_LIST_NAME = 'Koszyk',
  BASKET_SUGGESTION_PRODUCTS__LIST_NAME = 'Sugerowane produkty - koszyk',
  MODAL_BASKET_LIST_NAME = 'Modal koszyka',
  BESTSELLERS_LIST_NAME = 'Wasze ulubione',
  PRODUCT_PAGE_LIST_NAME = 'Strona produktu',
  SPECIAL_PROMOTION_ITEMS_LIST_NAME = 'Specjalne promocje',
  SUGGESTED_PRODUCTS_LIST_NAME = 'Sugerowane produkty',
  PROMOTIONS_LIST_NAME = 'Promocje',
  PROMOTIONS_PAGE_LIST_NAME = 'Strona promocji',
  RECENTLY_ADDED_PRODUCTS_LIST_NAME = 'Nowości',
  MOST_FREQUENTLY_BOUGHT_LIST_NAME = 'Najczęściej kupowane',
  RECENTLY_VIEWED_LIST_NAME = 'Ostatnio oglądane',
  FAVOURITES_LIST_NAME = 'Ulubione',
  SEARCH_HUB_PROMOTIONS_LIST_NAME = 'Wyszukiwarka - Nasze promocje',
  CART_ORDER_PRODUCTS = 'Kolejność w koszyku',
  OTHER_PRODUCTS_FROM_THIS_CATEGORY = 'Inne produkty z tej kategorii',
  BRAND_PAGE_LIST_NAME = 'Strona wytwórcy: {name}',
  CATEGORY_PAGE_LIST_NAME = 'Kategoria: {name}',
  REPEAT_ORDER_PRODUCTS = 'Powtórz zamówienie',
  ALL_PRODUCTS_PAGE_LIST_NAME = 'Wszystkie produkty',
  SEARCH_LIST_NAME = 'Wyszukiwarka'
}
